// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"57bbcdbf","455":"306c8a84","977":"b9924780"}[chunkId] + ".chunk.js";
};